import { Fragment, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Cleave from "cleave.js/react";
//--------------------------------------------------------------------------------------------
import OutsideServiceDivisionForm from "src/components/outside/outsideDivision/outsideDivisionForm";
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, 
    objAscSort, 
    boolAndReducer, 
    isDevMode, 
    MyFormData, 
    getTimeStamp,
    appTitle, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function OutsideServiceDivision({ tabTitle }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const inputRef = useRef(null);
    const history = useHistory();
    //--------------------------------------------------------------------------------------------
    const [showForm, setShowForm] = useState(false);
    const [active, setActive] = useState({});
    const [showLoading, setShowLoading] = useState(false);
    //--------------------------------------------------------------------------------------------
    const divisions = useMyStore(state => state.outsideserviceLocatorDivisions);
    const setDivisions = useMyStore(state => state.setOutsideserviceLocatorDivisions);
    const [updateDateTime, setUpdateDateTime] = useState({
        "Divisions": divisions.updatedAt === null?getTimeStamp():divisions.updatedAt
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(50);
    const [filterWords, setFilterWords] = useState("");
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredDivisions = divisions.data.filter(u => 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true)) 
    );
    const currentDivisions = filteredDivisions.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredDivisions.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect 1");
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            //-------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("outside/divisions/readDivisions.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-------------------------------------------------
            setDivisions(res.data.sort((a, b) => objAscSort(a, b, "division")), updateDateTime["Divisions"]);
        }
        if(updateDateTime["Divisions"] !== divisions.updatedAt) getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [history, updateDateTime["Divisions"]])
    useEffect(() => {
        if(isDevMode) console.log("useEffect 2");
        if(inputRef.current){
            inputRef.current.focus();
        }
    },[active])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Outside Divisions
                    <span
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "pointer" onClick = {() => setShowForm(true)}>Add</span>
                {showForm?
                <OutsideServiceDivisionForm
                    closeIt = {() => setShowForm(false)}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                />
                :<></>}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !currentDivisions.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th>Division</th>
                                <th>Supervisor Name</th>
                                <th>Supervisor Email</th>
                                <th>Role</th>
                                <th>Supervisor Phone Number</th>
                                <th>Region</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentDivisions.map((contact, key) => 
                            <Fragment key = {key}>
                            <tr
                                id = {contact.contactHashKey}
                                onDoubleClick = {async(e) => {
                                    setActive({
                                        division: contact.division, 
                                        key: e.target.id, 
                                        value: e.target.innerText
                                    });
                                }}
                            >
                                {["division", "supervisorName", "supervisorEmail", "role", "supervisorPhone", "region"].map((key, keyIndex) =>
                                    <td key = {keyIndex} id = {key}>
                                        {active.division === contact.division && active.key === key?
                                        (active.key === "supervisorPhone"?
                                        <Cleave
                                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                                            className = "form-control flex-grow-1"
                                            options = {{ 
                                                blocks:[3, 3, 4],
                                                delimiter: "-",
                                                numericOnly: true,
                                            }}
                                            value = {active.value}
                                            onChange = {e => {
                                                    setActive({
                                                    ...active, 
                                                    value: e.currentTarget.value
                                                });
                                            }}
                                            onBlur = {async(e) => {
                                                if(!e.currentTarget.checkValidity()){
                                                    window.alert("Input not valid.");
                                                    setActive({});
                                                    return;
                                                }
                                                if(contact[key] !== active.value){
                                                    if(window.confirm("Are you sure to update this value?")){
                                                        //-------------------------------------------------
                                                        const formData = new MyFormData();
                                                        formData.append("division", active.division);
                                                        formData.append("key", active.key);
                                                        formData.append("value", active.value);
                                                        setShowLoader(true);
                                                        const res = await myAxios("outside/divisions/updateDivision.php", formData);
                                                        setShowLoader(false);
                                                        if(!res) return;
                                                    //-------------------------------------------------
                                                    setDivisions(divisions.data.map(division => division.division === contact.division?{...division, [active.key]: active.value}:division));
                                                    }
                                                }
                                                setActive({});
                                            }}
                                        />:
                                        <textarea
                                            onFocus = {e => {
                                                const target = e.currentTarget;
                                                target.selectionStart = 
                                                target.selectionEnd = 
                                                target.value.length;
                                            }}
                                            ref = {inputRef}
                                            className = "form-control"
                                            value = {active.value}
                                            onChange = {e => {
                                                setActive({
                                                    ...active, 
                                                    value: e.currentTarget.value
                                                });
                                            }}
                                            onBlur = {async() => {
                                                let value = active.value;
                                                if(value !== "N/A"){
                                                    if(active.key === "supervisorEmail"){
                                                        value = value.replace(/ /g, "").toUpperCase();
                                                    }else{
                                                        value = value.replace(/\n/g, " ").replace(/\s+/g, " ").trim();
                                                        const propercCaseValue = value.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
                                                        if(value !== propercCaseValue){
                                                            if(window.confirm(`Do you want to change your input from "${value}" to "${propercCaseValue}"?\n(correct to proper case)`)){
                                                                value = propercCaseValue;
                                                            }
                                                        }
                                                    }
                                                }
                                                if(contact[key] !== value){
                                                    if(window.confirm("Are you sure to update this value?")){
                                                        //-------------------------------------------------
                                                        const formData = new MyFormData();
                                                        formData.append("division", active.division);
                                                        formData.append("key", active.key);
                                                        formData.append("value", value);
                                                        setShowLoader(true);
                                                        const res = await myAxios("outside/divisions/updateDivision.php", formData);
                                                        setShowLoader(false);
                                                        if(!res) return;
                                                    //-------------------------------------------------
                                                    setDivisions(divisions.data.map(division => division.division === contact.division?{...division, [active.key]: value}:division));
                                                    }
                                                }
                                                setActive({});
                                            }}
                                        />
                                        )
                                        :contact[key]}
                                    </td>
                                )}
                                <td>
                                    <span
                                        className = "btn btn-danger"
                                        onClick = {async() => {
                                            if(!window.confirm("Are you sure to delete this division?")) return;
                                            //-------------------------------------------------
                                            const formData = new MyFormData();
                                            console.log(contact.division)
                                            formData.append("division", contact.division);
                                            setShowLoader(true);
                                            const res = await myAxios("outside/divisions/deleteDivision.php", formData);
                                            setShowLoader(false);
                                            if(!res) return;
                                            //-------------------------------------------------
                                            setDivisions(divisions.data.filter(division => division.division !== contact.division));
                                        }}
                                    >
                                        X
                                    </span>
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && currentDivisions.length?
                <Footer
                    length = {currentDivisions.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}